<template>
  <TheMaster v-if="$store.state.master.isSignin" title="사용자" description="업체 사용자를 한 눈에 확인해보세요.">
    <a-input-search
      style="margin-bottom: 20px;"
      placeholder="검색"
      v-model="search"
      @search="refreshUsers"
      enterButton
    />

    <a-table
      :columns="columns"
      :loading="isLoading"
      :dataSource="accounts"
      size="middle"
      :locale="{ emptyText: '사용자가 없습니다.' }"
    >
      <a
        @click="viewUser(idx)"
        slot="name"
        slot-scope="_, { name, hostname, idx }"
        style="color: #1890ff !important;"
      >{{ name }}({{ hostname }})</a>
    </a-table>
    <a-button
      style="margin-top: 20px;"
      type="primary"
      icon="plus"
      @click="$router.push('/master/users/add')"
    >추가</a-button>
  </TheMaster>
</template>
<script>
import TheMaster from "@/components/Master/TheMaster";
import Axios from "axios";
import config from "../../../config";
import AxiosMiddleware from "../../../libs/AxiosMiddleware";
import OPCODE from "../../../libs/OPCODE";
import _ from "lodash";

export default {
  name: "MasterDashboard",
  components: { TheMaster },
  mounted() {
    this.refreshUsers();
  },
  methods: {
    viewUser(idx) {
      this.$router.push("/master/users/" + idx);
    },
    async refreshUsers() {
      this.isLoading = true;
      try {
        const { data } = await Axios.get(`${config.hostname}/v1/master/users`, {
          withCredentials: true,
          params: { q: this.search }
        });

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.accounts = _.map(data.companies, account => {
                account.key = account.idx;
                const moment = this.$moment(account.expiry);
                account.amount = `${account.amount.toLocaleString()}원`;
                account.expiry = this.isPC
                  ? moment.format("LLL")
                  : moment.fromNow();

                return account;
              });
              break;
          }
        }
      } catch {
        config.alert.mixin({
          type: "error",
          title:
            "사용자 정보를 가져올 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
      this.isLoading = false;
    }
  },
  data() {
    return {
      isLoading: false,
      columns: [
        {
          title: "이름",
          dataIndex: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "금액",
          dataIndex: "amount"
        },
        {
          title: "만료일",
          dataIndex: "expiry"
        }
      ],
      accounts: [],
      search: ""
    };
  }
};
</script>